<button class="ui-button d-flex align-items-center" [ngClass]="classList()" [disabled]="disabled()" [type]="type()">
  <span class="label">{{ label() }}</span>
</button>
